// converts a duration(sec) into a zero padded wall clock ##:##
export default function (duration: number) {
  const ms = getMinutesSeconds(duration)

  const min = ms.minutes < 10 ? `0${ms.minutes}` : ms.minutes.toString()
  const sec = ms.seconds < 10 ? `0${ms.seconds}` : ms.seconds.toString()

  return `${min}:${sec}`
}
